/* HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useState } from "react";

import { useNavigate } from "react-router-dom";

export const LayoutContext = createContext();

export const LayoutProvider = (props) => {
    const navigate = useNavigate();
    const [alert, setAlert] = useState({
        open: false,
        message: "",
        severity: "error",
    });

    const [loader, setLoader] = useState({
        open: false,
        message: "Loading...",
    });

    const [menuClientOpen, setMenuClientOpen] = useState(false);
    const [menuDashboardOpen, setMenuDashboardOpen] = useState(true);

    const [detailDashboardOpen, setDetailDashboardOpen] = useState(true);
    const [clavePaginaActual, setClavePaginaActual] = useState("");
    const [grupoMenuActual, setGrupoMenuActual] = useState("");

    const handleOpenDetailDashboard = () => {
        setDetailDashboardOpen(true);
    };

    const handleCloseDetailDashboard = () => {
        setDetailDashboardOpen(false);
    };

    const handleOpenMenuClient = () => {
        setMenuClientOpen(true);
    };

    const handleCloseMenuClient = () => {
        setMenuClientOpen(false);
    };

    const handleOpenMenuDashboard = () => {
        setMenuDashboardOpen(true);
    };

    const handleCloseMenuDashboard = () => {
        setMenuDashboardOpen(false);
    };

    const handleOpenAlert = (message, severity = "error") => {
        setAlert({
            open: true,
            message:message,
            severity:severity,
        });
    };

    const handleCloseAlert = () => {
        setAlert({
            ...alert,
            open: false,
        });
    };

    const handleOpenLoader = (message) => {
        setLoader({
            open: true,
            message,
        });
    };

    const handleCloseLoader = () => {
        setLoader({
            ...loader,
            open: false,
        });
    };

    const handleClickGoTo = (value) => {
        navigate(value);
    };

    const handleChangeTitle = (value) => {
        document.querySelector("title").innerHTML = "title - " + value;
    };

    const handleChangeClavePaginaActual = (value) => {
        setClavePaginaActual(value);
    };

    const handleChangeGrupoMenu = (value) => {
        setGrupoMenuActual(value);
    };

    return (
        <LayoutContext.Provider
            value={{
                alert,
                loader,
                menuClientOpen,
                menuDashboardOpen,
                detailDashboardOpen,
                clavePaginaActual,
                handleOpenDetailDashboard,
                handleCloseDetailDashboard,
                handleOpenMenuDashboard,
                handleCloseMenuDashboard,
                handleOpenMenuClient,
                handleCloseMenuClient,
                handleOpenAlert,
                handleCloseAlert,
                handleOpenLoader,
                handleCloseLoader,
                handleClickGoTo,
                handleChangeTitle,
                handleChangeClavePaginaActual,
                handleChangeGrupoMenu,
                grupoMenuActual,
            }}
        >
            {props.children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => useContext(LayoutContext);
